import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import DeleteIcon from '@mui/icons-material/Delete';
import { alpha, Theme } from '@mui/material/styles';
import { useTranslation } from 'react-i18next';

interface EnhancedTableToolbarProps {
    numSelected: number;
    count: number;
    onDeleteSelected: () => void;
}

export default function EnhancedTableToolbar({ numSelected, count, onDeleteSelected }: EnhancedTableToolbarProps) {
    const { t } = useTranslation();
    return (
        <Toolbar
            sx={{
                pl: { sm: 2 },
                pr: { xs: 1, sm: 1 },
                ...(numSelected > 0 && {
                    bgcolor: (theme: Theme) =>
                        alpha(theme.palette.primary.main, theme.palette.action.activatedOpacity),
                }),
            }}
        >
            <Typography sx={{ flex: '1 1 100%' }} color="text.secondary" variant="subtitle1" component="div">
                {numSelected > 0 ? t('userManagement.selectedCount', { count: numSelected }) : t('userManagement.membersCount', { count })}
            </Typography>

            {numSelected > 0 ? (
                <Tooltip title={t('common.deleteSelected')}>
                    <IconButton onClick={onDeleteSelected} aria-label={t('common.deleteSelected')}>
                        <DeleteIcon />
                    </IconButton>
                </Tooltip>
            ) : null}
        </Toolbar>
    );
}
